import { axios, handleError } from '../axios';

export const trashRestore = () => {
  return new Promise((resolve) => {
    axios
      .post('admin/trash/restore/', {})
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
